// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__pRj80","footer":"ModalInfo_footer__351G0"};